import { ref } from 'vue';

const modules = import.meta.glob<{ default: ThemeOptions }>('../themes/*.yml', {
  eager: true
});

const themePresets = ref({});

for (const path in modules) {
  const name = path.match(/theme-([^.]+)\.yml$/)?.[1];
  if (name) themePresets.value[name] = modules[path].default;
}

if (import.meta.hot) {
  import.meta.hot.accept(newFoo => {
    themePresets.value = newFoo.default.value;
  });
}

export default themePresets;
